<template>
  <div v-bind="$attrs" class="text-caption"><slot></slot></div>
</template>

<script>

export default {
  name: 'field-hint',
};
</script>